import { StressValue } from 'root-constants'

export const SCALE_VALUES = [
  { id: '1', maxWidth: 5, bottomValue: 98, firstValue: 20 },
  { id: '2', maxWidth: 60, bottomValue: 90, firstValue: 15, secondValue: 25 },
  { id: '3', maxWidth: 95, bottomValue: 70, firstValue: 10, secondValue: 30 },
  { id: '4', maxWidth: 100, bottomValue: 40, firstValue: 5, secondValue: 35 },
  { id: '5', maxWidth: 90, bottomValue: 15, firstValue: 0, secondValue: 40 },
]

export const POINTER_COORDINATES_MAP = {
  [StressValue.LOW]: {
    rotationAngle: -31,
    left: 49,
    bottom: 21,
    minPhoneBottom: 23,
  },
  [StressValue.MODERATE]: {
    rotationAngle: 32,
    left: 51,
    bottom: 21,
    minPhoneBottom: 23,
  },
  [StressValue.SEVERE]: {
    rotationAngle: 130,
    left: 51.3,
    bottom: 11,
    minPhoneBottom: 15,
  },
}
